import { render } from "./DadosBancarios.vue?vue&type=template&id=8b045aac&scoped=true"
import script from "./DadosBancarios.vue?vue&type=script&lang=js"
export * from "./DadosBancarios.vue?vue&type=script&lang=js"

import "./DadosBancarios.vue?vue&type=style&index=0&id=8b045aac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b045aac"]])

export default __exports__